import { inject } from 'aurelia';
import { Helper } from './../resources/extensions/helper';
import { ApiService } from './api-service';
import { websiteShortCode } from '../environment';
import { Language } from '../state/models/ILanguage';

@inject(ApiService, Helper)
export class LanguageWebsiteService {
    path = 'LanguageWebsite';
    languages: Language[] | null = null;

    constructor(private api: ApiService, private helper: Helper) {
        this.api = api;
        this.helper = helper;
    }

    async getByWebsite() {
        return this.helper.handlePendingRequest(this, async() => {
            if (this.languages) return this.languages;
            this.languages = await this.api.doGet(`${this.path}/ByWebsite?websiteShortCode=${websiteShortCode()}`);
            return this.languages?.sort((a, b) => {
                return (Number(b.position !== null) - Number(a.position !== null)) || ((a.position ?? 0) - (b.position ?? 0)) || (a.language?.name?.localeCompare(b.language?.name ?? '') ?? 0);
            });
        });
    }
}
